export const COLORING_TYPES = [
  { id: 'inverno_brilhante', label: 'Inverno Brilhante' },
  { id: 'inverno_frio', label: 'Inverno Frio' },
  { id: 'inverno_escuro', label: 'Inverno Escuro' },
  { id: 'verao_suave', label: 'Verão Suave' },
  { id: 'verao_frio', label: 'Verão Frio' },
  { id: 'verao_claro', label: 'Verão Claro' },
  { id: 'outono_escuro', label: 'Outono Escuro' },
  { id: 'outono_suave', label: 'Outono Suave' },
  { id: 'outono_quente', label: 'Outono Quente' },
  { id: 'primavera_clara', label: 'Primavera Clara' },
  { id: 'primavera_brilhante', label: 'Primavera Brilhante' },
  { id: 'primavera_quente', label: 'Primavera Quente' }
]